// Supabase kaldırıldı - Bu dosya sadece placeholder olarak tutuluyor
// Backend API kullanılıyor

export const getSupabaseClient = async () => {
  return null;
};

export const getSupabaseConfig = () => {
  return { supabaseUrl: null, supabaseAnonKey: null };
};

export const testSupabaseConnection = async () => {
  return { success: false, error: 'Supabase kaldırıldı' };
};

export const getDatabaseInfo = async () => {
  return { success: false, error: 'Supabase kaldırıldı' };
};

export const checkTablesEmpty = async () => {
  return { isEmpty: false, hasTables: true };
};

export default getSupabaseClient;
